import * as React from "react";
import Svg, { Path } from "react-native-svg";

const HistoryBottomIcon = (props) => (
  <Svg
    width={45}
    height={45}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M39.375 22.5V8.437a2.812 2.812 0 0 0-2.813-2.812H8.439a2.813 2.813 0 0 0-2.813 2.813v28.124a2.812 2.812 0 0 0 2.813 2.813H22.5"
      stroke={props.color}
      strokeWidth={2.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M30 35.625a5.625 5.625 0 1 0 0-11.25 5.625 5.625 0 0 0 0 11.25Z"
      stroke={props.color}
      strokeWidth={2.5}
    />
    <Path
      d="m34.688 33.75 4.687 3.75M13.125 15h18.75m-18.75 7.5h7.5"
      stroke={props.color}
      strokeWidth={2.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
HistoryBottomIcon.props = {
  color: "#fff",
};
export default HistoryBottomIcon;
